import { render, staticRenderFns } from "./VasInfo.vue?vue&type=template&id=7f42524c&scoped=true&"
import script from "./VasInfo.vue?vue&type=script&lang=js&"
export * from "./VasInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42524c",
  null
  
)

export default component.exports